export const Paragraph = (props: {
  children: React.ReactNode;
  className?: string;
}) => {
  return <p className={`my-4 ${props.className ?? ""}`}>{props.children}</p>;
};
